import React, { Component } from "react";
import ReactDOM from "react-dom";
import L from "leaflet";
import { Map, Polyline, Popup, TileLayer, Marker } from "react-leaflet";
import { PolylineDecorator } from "./PolylineDecorator";

import {line} from "./lines";

export class App extends Component {
    render() {
        const { posts } = this.props;
        console.log(posts);
        const access_token =
            "pk.eyJ1IjoiaGF3YWlpZG8iLCJhIjoiY2lyNHhud3ZtMDAzdGh6bTlxNXhtYml0cCJ9.OKyXF_spDCqzhrlSD7OeLQ";

        const center = [46.50, 6.715];

        const zoom = 14;

        /*const blueArrow = L.Symbol.arrowHead({
            pixelSize: 15,
            pathOptions: { fillOpacity: 1, weight: 0, color: "#009ee3" }
        });

        const orangeArrow = L.Symbol.arrowHead({
            pixelSize: 15,
            pathOptions: { fillOpacity: 1, weight: 0, color: "#f39200" }
        });

        const pinkArrow = L.Symbol.arrowHead({
            pixelSize: 15,
            pathOptions: { fillOpacity: 1, weight: 0, color: "#e6007e" }
        });

        let busIcon = L.divIcon({
            className: "bus-stop-icon",
            html: `<img src="${assetsUrl}/assets/static/bus-stop.svg">`,
            iconSize: L.point(18, 18)
        });

        let parkingIcon = L.divIcon({
            className: "parking-icon",
            html: `<img src="${assetsUrl}/assets/static/parking.svg">`,
            iconSize: L.point(18, 18)
        });*/

        let startIcon = L.divIcon({
            className: "start-icon",
            html: `<svg fill="#2d1a00" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 37.9 54.6" xml:space="preserve"><path d="M28.5 14.2L18.6 0 8.8 14.2H17v25.7h3.3V14.2zM3.7 43.8c.6 0 1.1.1 1.5.3.5.2.9.4 1.2.8.3.4.6.8.8 1.3.2.5.3 1.1.3 1.9 0 .6-.1 1.2-.2 1.7s-.4 1-.7 1.4c-.3.4-.7.7-1.2.9-.5.2-1.1.3-1.7.3H0v-8.6h3.7zm-.1 7c.3 0 .5 0 .8-.1.3-.1.5-.2.7-.4.2-.2.4-.5.5-.8.1-.3.2-.7.2-1.2 0-.4 0-.8-.1-1.2-.1-.3-.2-.6-.4-.9-.2-.2-.4-.4-.8-.6-.3-.1-.7-.2-1.2-.2H1.9v5.4h1.7zM10.5 50.9c.3.2.6.4 1.1.4.3 0 .6-.1.9-.3l.5-.5h1.5c-.2.7-.6 1.3-1.1 1.6-.5.3-1.1.5-1.8.5-.5 0-.9-.1-1.3-.2-.4-.2-.7-.4-1-.7-.3-.3-.5-.6-.6-1s-.2-.8-.2-1.3.1-.9.2-1.3c.2-.4.4-.7.6-1 .3-.3.6-.5 1-.7.4-.2.8-.3 1.3-.3s1 .1 1.4.3.7.5 1 .8c.3.3.4.7.5 1.2.1.4.2.9.1 1.4h-4.5c0 .5.2.9.4 1.1zm2-3.2c-.2-.2-.5-.3-.9-.3-.3 0-.5 0-.7.1-.2.1-.3.2-.4.3s-.2.3-.2.4-.1.3-.1.4H13c-.2-.4-.3-.7-.5-.9zm-.6-4.7l-1.3 2.1h1.2l2-2.1h-1.9zM17.2 46.2v.8c.2-.3.5-.6.8-.7.3-.2.7-.2 1.1-.2.5 0 .9.1 1.3.3.4.2.6.4.9.7.2.3.4.7.5 1.1.1.4.2.8.2 1.3 0 .4-.1.8-.2 1.2-.1.4-.3.7-.5 1-.2.3-.5.5-.9.7-.3.2-.7.3-1.2.3-.4 0-.7-.1-1.1-.2-.3-.2-.6-.4-.8-.7v2.9h-1.7v-8.4h1.6zm2.2 4.9c.2-.1.3-.3.5-.4.1-.2.2-.4.2-.6 0-.2.1-.5.1-.7s0-.5-.1-.7c-.1-.2-.1-.5-.3-.6s-.3-.3-.5-.5c-.2-.1-.4-.2-.7-.2-.3 0-.5.1-.7.2-.2.1-.3.3-.5.5-.1.2-.2.4-.2.6 0 .2-.1.5-.1.7 0 .2 0 .5.1.7.1.2.1.5.3.6.1.2.3.3.5.4.2.1.4.2.7.2.3 0 .5-.1.7-.2zM22.9 48.1c0-.4.1-.7.3-1 .2-.3.4-.5.7-.6.3-.2.6-.3.9-.3.3-.1.7-.1 1-.1.3 0 .6 0 .9.1.3 0 .6.1.9.3s.5.3.6.5.3.5.3.9V51.8c0 .3.1.4.2.6H27c0-.1-.1-.2-.1-.3v-.3c-.3.3-.6.5-1 .6-.4.1-.7.2-1.1.2-.3 0-.6 0-.8-.1-.3-.1-.5-.2-.7-.3-.2-.2-.3-.3-.5-.6s-.2-.5-.2-.8c0-.4.1-.6.2-.9s.3-.4.5-.5c.2-.1.4-.2.7-.3.3-.1.5-.1.8-.2.3 0 .5-.1.8-.1.2 0 .5-.1.7-.1.2 0 .3-.1.5-.2.1-.1.2-.2.2-.4s0-.3-.1-.4-.1-.2-.2-.3c-.1-.1-.2-.1-.3-.1H26c-.3 0-.6.1-.8.2-.2.1-.3.4-.3.7h-2zm3.9 1.3c-.1.1-.2.1-.3.1-.1 0-.2.1-.3.1s-.3 0-.4.1-.3 0-.4.1c-.1 0-.3.1-.4.1s-.2.1-.3.2c-.1.1-.2.2-.2.3-.1.1-.1.2-.1.4s0 .3.1.4.1.2.2.2c.1.1.2.1.3.1h.4c.3 0 .6-.1.8-.2.2-.1.3-.2.4-.4.1-.2.1-.3.2-.5v-1zM31.4 46.2v1.2c.1-.2.2-.4.3-.5.1-.2.3-.3.5-.4l.6-.3c.2-.1.4-.1.6-.1.1 0 .2 0 .4.1v1.6h-.6c-.3 0-.6.1-.8.2-.2.1-.4.2-.5.4l-.3.6c-.1.2-.1.5-.1.8v2.8h-1.7v-6.2h1.6zM37.9 46.2v1.1h-1.2v3.1c0 .3 0 .5.1.6.1.1.3.1.6.1h.6v1.3h-1c-.3 0-.5 0-.8-.1-.2 0-.4-.1-.6-.2s-.3-.3-.4-.4-.2-.4-.2-.8v-3.7h-1v-1.1h1v-1.9h1.7v1.9h1.2z"/></svg>`,
            iconSize: L.point(42, 42),
            iconAnchor: [21, 0]
        });


        const blueArrow = L.Symbol.arrowHead({
            pixelSize: 14,
            pathOptions: { fillOpacity: 0, weight: 0, color: "#a96001",  },
        });



        return (
            <Map center={center} zoom={zoom} id="map" scrollWheelZoom={false}>
                <TileLayer
                    attribution=""
                    url={`https://api.mapbox.com/styles/v1/mapbox/outdoors-v11/tiles/256/{z}/{x}/{y}?access_token=${access_token}`}
                />

                <Polyline color="#a96001" positions={line} weight={3}>
                    <Popup>Ligne Bleue</Popup>
                    <PolylineDecorator
                        patterns={[
                            {
                                offset: 0,
                                repeat: 150,
                                symbol: blueArrow
                            }
                        ]}
                        positions={line}
                        stroke={false}
                    />
                </Polyline>

                {/* <Marker icon={startIcon} position={[46.488341, 6.730900]}></Marker> */}

            {posts.map((post, i) => {

                if (!post.fields.fr.latitude || !post.fields.fr.longitude) {
                    return <React.Fragment key={i} />;
                }

                const icon = L.divIcon({
                    className: "post-icon",
                    html: post.fields.fr.poste_number,
                    iconSize: L.point(30, 30)
                });
                return (
                    <Marker
                        key={i}
                        title={post.title.fr}
                        icon={icon}
                        position={[post.fields.fr.latitude, post.fields.fr.longitude]}
                    >
                        <Popup>
                        <a href={`${post.link}`} className="marker-link">
                            {post.title.fr}
                        </a>
                        </Popup>
                    </Marker>
                );
            })}
            </Map>
        );
    }
}

const mapElement = document.querySelector("#map-container");
if (mapElement)
    ReactDOM.render(
        <App
            posts={JSON.parse(mapElement.dataset.posts)}
        />,
        mapElement
    );
